// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
Loading dots taken from: https://css-tricks.com/single-element-loaders-the-dots/
*/
.loading-dots {
    width: 60px;
    aspect-ratio: 5;
    background: radial-gradient(circle closest-side, #909090 90%, #0000) 0 / calc(100% / 3) 100% space;
    clip-path: inset(0 100% 0 0);
    animation: d1 1s steps(4) infinite;
}

@keyframes d1 {
    to {
        clip-path: inset(0 -34% 0 0);
    }
}
`, "",{"version":3,"sources":["webpack://./src/fpp-app/loading/loading.css"],"names":[],"mappings":"AAAA;;CAEC;AACD;IACI,WAAW;IACX,eAAe;IACf,kGAAkG;IAClG,4BAA4B;IAC5B,kCAAkC;AACtC;;AAEA;IACI;QACI,4BAA4B;IAChC;AACJ","sourcesContent":["/*\nLoading dots taken from: https://css-tricks.com/single-element-loaders-the-dots/\n*/\n.loading-dots {\n    width: 60px;\n    aspect-ratio: 5;\n    background: radial-gradient(circle closest-side, #909090 90%, #0000) 0 / calc(100% / 3) 100% space;\n    clip-path: inset(0 100% 0 0);\n    animation: d1 1s steps(4) infinite;\n}\n\n@keyframes d1 {\n    to {\n        clip-path: inset(0 -34% 0 0);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
